import _slicedToArray from "/codebuild/output/src4035996522/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import assert from './assert';
import { log2, clamp } from './math-utils';
import { MAX_LATITUDE, lngLatToWorld, worldToLngLat } from './web-mercator-utils';
export default function fitBounds(options) {
  var width = options.width,
      height = options.height,
      bounds = options.bounds,
      _options$minExtent = options.minExtent,
      minExtent = _options$minExtent === void 0 ? 0 : _options$minExtent,
      _options$maxZoom = options.maxZoom,
      maxZoom = _options$maxZoom === void 0 ? 24 : _options$maxZoom,
      _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;

  var _bounds = _slicedToArray(bounds, 2),
      _bounds$ = _slicedToArray(_bounds[0], 2),
      west = _bounds$[0],
      south = _bounds$[1],
      _bounds$2 = _slicedToArray(_bounds[1], 2),
      east = _bounds$2[0],
      north = _bounds$2[1];

  var padding = getPaddingObject(options.padding);
  var nw = lngLatToWorld([west, clamp(north, -MAX_LATITUDE, MAX_LATITUDE)]);
  var se = lngLatToWorld([east, clamp(south, -MAX_LATITUDE, MAX_LATITUDE)]);
  var size = [Math.max(Math.abs(se[0] - nw[0]), minExtent), Math.max(Math.abs(se[1] - nw[1]), minExtent)];
  var targetSize = [width - padding.left - padding.right - Math.abs(offset[0]) * 2, height - padding.top - padding.bottom - Math.abs(offset[1]) * 2];
  assert(targetSize[0] > 0 && targetSize[1] > 0);
  var scaleX = targetSize[0] / size[0];
  var scaleY = targetSize[1] / size[1];
  var offsetX = (padding.right - padding.left) / 2 / scaleX;
  var offsetY = (padding.top - padding.bottom) / 2 / scaleY;
  var center = [(se[0] + nw[0]) / 2 + offsetX, (se[1] + nw[1]) / 2 + offsetY];
  var centerLngLat = worldToLngLat(center);
  var zoom = Math.min(maxZoom, log2(Math.abs(Math.min(scaleX, scaleY))));
  assert(Number.isFinite(zoom));
  return {
    longitude: centerLngLat[0],
    latitude: centerLngLat[1],
    zoom: zoom
  };
}

function getPaddingObject() {
  var padding = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  if (typeof padding === 'number') {
    return {
      top: padding,
      bottom: padding,
      left: padding,
      right: padding
    };
  }

  assert(Number.isFinite(padding.top) && Number.isFinite(padding.bottom) && Number.isFinite(padding.left) && Number.isFinite(padding.right));
  return padding;
}